exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Talepler[data-v-24ee2476]{list-style:none;margin:0;padding:0;background:#dddfe7;border-radius:0 0 4px 4px;margin-top:-10px;padding-top:20px;padding-bottom:20px;height:77vh;overflow:scroll}.Talepler li[data-v-24ee2476]:last-child{border-bottom:0}.Talepler li.aktif[data-v-24ee2476]{background-color:#00c391}.Talepler li[data-v-24ee2476]{padding:10px;border-bottom:1px solid #ccc;color:#333;font-size:12px;cursor:pointer;height:56px;line-height:18px}.Talepler li span.Baslik[data-v-24ee2476]{display:block;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.Talepler li span.Firma[data-v-24ee2476]{float:left;width:100px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-size:10px}.Talepler li span.tarih[data-v-24ee2476]{float:right;font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24ee2476","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Doc/Destek/DestekSayfa.vue
// module id = 1373
// module chunks = 0